import * as React from 'react';
import { cn } from '../../lib/shadcn-utils';

const Textarea = React.forwardRef(({ className, ...props }, ref) => (
  <textarea
    className={cn(
      'flex min-h-[80px] w-full rounded-md border border-emerald-700/70 bg-emerald-950/80 px-3 py-2 text-sm text-emerald-50 placeholder:text-emerald-300/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime-300/30 disabled:cursor-not-allowed disabled:opacity-50',
      className
    )}
    ref={ref}
    {...props}
  />
));
Textarea.displayName = 'Textarea';

export { Textarea };

